<div class="horizinns-container center horizinns-main-container-padding">
    <mat-card class="horizinns-card faq-card even-more-blur mw-80">
        <mat-card-content>
            <div class="faq-container">
                <div class="faq-header">
                    <img src="assets/images/logo_full_900.png" alt="Horizinns Logo" class="main-logo margin-auto"/>
                    <h1>Frequently Asked Questions</h1>
                </div>
                <div class="category-filters">
                    <mat-chip-listbox aria-label="FAQ Categories">
                    <mat-chip-option 
                        [selected]="activeCategory() === 'All'" 
                        (selectionChange)="selectCategory('All')"
                        color="primary">
                        All
                    </mat-chip-option>

                    @for (cat of categories(); track cat.title) {
                        <mat-chip-option 
                        [selected]="activeCategory() === cat.title"
                        (selectionChange)="selectCategory(cat.title)"
                        color="accent">
                        {{ cat.title }}
                        </mat-chip-option>
                    }
                    </mat-chip-listbox>
                </div>

                <div class="faq-content">
                    @for (group of filteredData(); track group.title) {
                    
                    @if (activeCategory() === 'All') {
                        <h3 class="category-header">{{ group.title }}</h3>
                    }

                    <mat-accordion displayMode="flat" multi="false">
                        @for (item of group.items; track $index) {
                        
                        <mat-expansion-panel class="custom-panel" hideToggle>
                            <mat-expansion-panel-header>
                            <div class="header-content">
                                <span class="question-text">{{ item.question }}</span>
                                <div class="icon-container">
                                <mat-icon>add</mat-icon>
                                </div>
                            </div>
                            </mat-expansion-panel-header>

                            <div class="answer-text">
                                <div [innerHTML]="item.answer"></div>
                            </div>
                        </mat-expansion-panel>
                        
                        }
                    </mat-accordion>
                    }
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
